import { Component, Input, OnInit } from '@angular/core';
import { AbstractDataProvider } from 'src/app/AbstractDataProvider';
import { DataItemModel } from '../../../../shared/model/interfaces';
import { AuthServiceCustom } from '../../../../shared/service/auth.service';
import { DictionaryPipe } from '../../../../shared/pipes/dictionary.pipe';
import { GenericFilterModel, QueryStringParam } from '../../../security/QueryStringParam';
import {getErrorMessageText} from '../../../helper';


@Component({
    selector: 'app-documents-block',
    templateUrl: './documents-block.component.html',
    styleUrls: ['./documents-block.component.scss'],
    providers: [DictionaryPipe],
    standalone: false
})
export class DocumentsBlockComponent implements OnInit {

  @Input() statements: DataItemModel[] = [];
  @Input() taxes: DataItemModel[] = [];
  @Input() communications: DataItemModel[] = [];
  @Input() confirms: DataItemModel[] = [];
  @Input() label = '';
  @Input() differentLoggedIn: boolean;

  display = false;
  alertMessage: string;
  InboxCount = 0;
  TotalActiveCommitmentAmt = 0;
  TotalActiveCapitaltAmt = 0;
  TotalActiveUnits = 0;
  TotalActiveValueAmt = 0;
  statementsLink = '/statement';
  statementsTitle = 'STATEMENTS';
  downloadDocumentImagUrl: string = this.abstractDataProvider.baseUrl + 'api/File/FileDownloadFromDocumentImage?SeqNum=';

  constructor(private abstractDataProvider: AbstractDataProvider, private authService: AuthServiceCustom,
              private dictionaryPipe: DictionaryPipe) {
  }

  ngOnInit() {
    const menuList = this.authService.getMenuListBasedOnUserType();
    const idx = menuList.findIndex(i => i.Path === 'repStatement');
    if (idx > -1) {
      this.statementsTitle = 'ADVISOR_STATEMENTS';
      this.statementsLink = '/repStatement';
    }
  }


  Download(DocSeqNum: any, FileNum: any, AppendSeqNum: any) {
    this.abstractDataProvider.getData('api/File/IsFileExist?SeqNum=' + DocSeqNum + '&forWhat=form')
      .subscribe(
        posts => {
          if (posts.Message) {
            this.display = true;
            this.alertMessage = posts.Message;
          } else if (posts.DocSeqNum) {
            // window.open(this.downloadDocumentImagUrl + posts.DocSeqNum + '&forWhat=form&CurrentUserNumber=' + posts.CurrentUserNumber + '&FileNum=' + FileNum + '&AppendSeqNum=' + AppendSeqNum, '_blank');
            const url = this.downloadDocumentImagUrl + posts.DocSeqNum + '&forWhat=form&CurrentUserNumber=' + posts.CurrentUserNumber + '&FileNum=' + FileNum + '&AppendSeqNum=' + AppendSeqNum;
            this.abstractDataProvider.downloadFile(url)
            .subscribe(_ => {}, error =>{
              this.display = true;
              this.alertMessage = getErrorMessageText(error);
            });
          } else {
            // Not Found
            this.display = true;
            this.alertMessage = this.dictionaryPipe.transform('FILE_NOT_FOUND');
          }
        },
        error => {
          if (error.error && error.error.error_description) {
            this.display = true;
            this.alertMessage = error.error.error_description;
          } else {
            this.display = true;
            this.alertMessage =  getErrorMessageText(error);
          }
        }
      );
  }

  checkTaxTypeDownload(dataitem): void {
    if (dataitem.Location == "D") {
      this.downloadDocumentDynamic(dataitem);
    }
    else
    {
      this.DownloadTaxOrConfirms(dataitem.seqNum, dataitem.FileNum);
    }

  }

  DownloadTaxOrConfirms(DocSeqNum: any, FileNum: any) {
    this.abstractDataProvider.getData('api/File/IsFileExist?SeqNum=' + DocSeqNum + '&forWhat=tax')
      .subscribe(
        posts => {
          if (posts.Message) {
            this.display = true;
            this.alertMessage = posts.Message;
          } else if (posts.DocSeqNum) {
            // window.open(this.downloadDocumentImagUrl + posts.DocSeqNum + '&forWhat=tax&CurrentUserNumber=' + posts.CurrentUserNumber + '&FileNum=' + FileNum, '_blank');
            const url = this.downloadDocumentImagUrl + posts.DocSeqNum + '&forWhat=tax&CurrentUserNumber=' + posts.CurrentUserNumber + '&FileNum=' + FileNum;
            this.abstractDataProvider.downloadFile(url)
            .subscribe(_ => {}, error =>{
              this.display = true;
              this.alertMessage = getErrorMessageText(error);
            });
          } else {
            // Not Found
            this.display = true;
            this.alertMessage = this.dictionaryPipe.transform('FILE_NOT_FOUND');
          }
        },
        error => {
          this.display = true;
          this.alertMessage =  getErrorMessageText(error);
        }
      );
  }

  downloadDocumentDynamic(dataItem): void {
    const queryParam: QueryStringParam[] = [
      { Key: 'cboFundId', Value: dataItem.FundId },
      { Key: 'cboTaxYear', Value: dataItem.Year + '' },
      { Key: 'txtFax', Value: '' },
      { Key: 'chkMaskTaxId', Value: 'true' },
      { Key: 'chkFaxFlag', Value: 'false' },

      { Key: 'InvestorNum', Value: dataItem.InvestorNum },
      { Key: 'InvestmentNum', Value: dataItem.InvestmentNum },
      { Key: 'cboTaxType', Value: dataItem.FileType }
    ];
    const is1099 = ['1099DIV', '1099B', '1099INT', '1099OID'].includes(dataItem.FileType);
    const apiUrl = is1099
      ? 'api/Tax/GenerateDynamicTax1099'
      : 'api/Tax/GenerateDynamicTaxK1';

    this.abstractDataProvider.postData(queryParam, apiUrl).subscribe(
      posts => {
        if (posts.Data.url) {
          // window.open(this.abstractDataProvider.baseUrl + posts.Data.url, '_blank');
          const url = this.abstractDataProvider.baseUrl + posts.Data.url;
            this.abstractDataProvider.downloadFile(url)
            .subscribe(_ => {}, error =>{
              this.display = true;
              this.alertMessage = getErrorMessageText(error);
            });
        } else if (posts.Data.AlertMsgs.length > 0) {
          // TODO: implement
        }
      },
      error => {
        // TODO: implement
      }
    );
  }

  onConfirm() {
    this.display = false;
  }

  navigateToConfirmMsg() {
    this.authService.navigateToUrl('inbox', {type: 'confirms'});
  }


}
